import React from "react";
import { ReactElement } from "react";

import ModernImage from "pages/common/modern-image";
import Modern from "pages/common/modern";
import AuthDropdown from "pages/common/auth-dropdown";
import { BrandingData } from "admin-portal/settings/branding";

interface Props {
  children: ReactElement;
}
const ModernLayout: React.FC<Props> = (props: Props) => {
  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add("font-public");

    return () => {
      bodyElement.classList.remove("font-public");
    };
  }, []);

  return (
    <React.Fragment>
      <div className="relative flex flex-col w-full overflow-hidden xl:flex-row to-custom-800 bg-gradient-to-r from-custom-900 dark:to-custom-900 dark:from-custom-950">
        <ModernImage />
        <div className="min-h-[calc(100vh_-_theme('spacing.4')_*_2)] mx-3 lg:w-[40rem] shrink-0 px-10 py-14 flex items-center justify-center m-4 bg-white rounded z-10 relative dark:bg-zink-700 dark:text-zink-100 md:mx-auto xl:mx-4">
          <div className="flex flex-col w-full h-full">
            <AuthDropdown />
            <div className="my-auto">{props.children}</div>
            <div className="mt-5">
              <p className="mb-0 text-center text-15 text-slate-500 dark:text-zink-200">
                © {new Date().getFullYear()} {BrandingData.siteName}. Crafted with{" "}
                <i className="text-red-500 ri-heart-fill"></i> by{" "}
                <a
                  href="http://themesdesign.in"
                  className="underline transition-all duration-200 ease-linear text-slate-800 dark:text-zink-50 hover:text-custom-500"
                >
                  {BrandingData.poweredBy}
                </a>
              </p>
            </div>
          </div>
        </div>
        <Modern />
      </div>
    </React.Fragment>
  );
};

export default ModernLayout;
